import { combineReducers } from "redux";
import auth from "./auth/reducer";
import investigation from "./investigation/reducer";
import vizReducer from "./visualization/reducer";
import processorReducer from "./process/reducer";
import limitReducer from "./limit/reducer";
import batchReducer from "./batches/reducer";
import sharedReducer from "./shared/reducer";
import reviewReducer from "./review/reducer";
import auditReducer from "./audit/reducer";
import reportsReducer from "./reports/reducer";
import productReducer from "./product/reducer";
import siteReducer from "./site/reducer";
import uopReducer from "./uop/reducer";
import parameterReducer from "./parameter/reducer";
import auditConfigReducer from "./audit_config/reducer";
import genealogyReducer from "./genealogy/reducer";
import dashboardReducer from "./dashboard/reducer";

const appReducer = combineReducers({
  auth: auth,
  viz: vizReducer,
  investigation: investigation,
  proReducer: processorReducer,
  limitReducer: limitReducer,
  batch: batchReducer,
  auditReducer: auditReducer,
  shared: sharedReducer,
  reviewReducer: reviewReducer,
  reports: reportsReducer,
  product: productReducer,
  site: siteReducer,
  uop: uopReducer,
  process: parameterReducer,
  auditConfig: auditConfigReducer,
  genealogy: genealogyReducer,
  dashboard: dashboardReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
